import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import closeIcon from '@/assets/icon/close-icon.svg';
import Reject from '@/assets/smartcity/reject-icon.svg';
import Button from '@/shared/components/ui/Button';
import DetailForm from '@/shared/components/ui/DetailForm/DetailForm';

interface ModalConfirmationProps {
  isOpen?: boolean;
  onClose: () => void;
  onReject: (reason: string) => void;
  logData?: Record<string, any>;
}

const ModalConfirmation = ({ isOpen, onClose, onReject, logData }: ModalConfirmationProps) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[1000]">
      <div className="w-[30%] p-6 flex flex-col gap-3  bg-db-card border bg-db-border rounded-[5px] overflow-hidden">
        <div className="w-full flex flex-row gap-3 items-center">
          <img src={Reject} alt="reject icon" />
          <div className="flex flex-col">
            <span className="h5bold ">{t('cmn>master>reject report')}</span>
            <span className="title2 text-db-text-grey ">
              {t('psc>report>provide reject reason')}
            </span>
          </div>
        </div>

        <div className="">
          <DetailForm
            className="relative h-[230px]! "
            label={t('psc>report>reason for rejection')}
            direction="col"
            inputType="textarea"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>

        <div className="w-full flex justify-center pb-2 items-center m-auto gap-3">
          <Button
            bg-text-danger-300
            className="flex-1 btn-fill-red-ghost text-[20px]  cursor-pointer"
            label={t('cmn>master>cancel')}
            onClick={onClose}
          />
          <Button
            bg-text-danger-300
            className="flex-1 btn-fill-red text-[20px] cursor-pointer "
            label={t('cmn>master>reject report')}
            onClick={() => onReject(reason)}
          />
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmation;
